module.exports = __webpack_public_path__ + "image-c9bc39bb525b.png";